<div class="sort-indicator">
  <fa-icon [icon]="ICONS.UP" class="sort-indicator__up" [class.active]="sortDir === 'asc'"></fa-icon>
  <fa-icon [icon]="ICONS.DOWN" class="sort-indicator__down" [class.active]="sortDir === 'desc'"></fa-icon>
</div>
